var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarberaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 234.68 58.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1479ff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.45,31.09a9.37,9.37,0,0,1-9.72,9.4H58.18V9.61h8.43c5.32,0,8.93,3.83,8.93,7.93,0,3.33-2.32,5.56-3.47,5.56A7.84,7.84,0,0,1,79.45,31.09ZM63,14.32V22l3.83,0A3.88,3.88,0,0,0,71,18.17a4,4,0,0,0-4.1-3.85Zm11.7,16.44c0-2.34-2-4.48-5.5-4.48l-6.2,0v9.46h6.28A5.21,5.21,0,0,0,74.71,30.76Z",
    transform: "translate(-6.03 -2.28)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.17,35.8H87.55l-2.11,4.69H80.19L94.72,9H95l14.53,31.52h-5.25Zm-1.88-4.16L94.87,19.57,89.43,31.64Z",
    transform: "translate(-6.03 -2.28)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.94,40.49l-8.32-12h-3.79v12H113l0-30.88h9.6A10.2,10.2,0,0,1,133,19.53a9,9,0,0,1-6.11,8.6l9,12.36Zm-7.27-16A5.27,5.27,0,0,0,128,19.42a5.16,5.16,0,0,0-5.35-5h-4.86v10.1Z",
    transform: "translate(-6.03 -2.28)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.42,31.09a9.36,9.36,0,0,1-9.71,9.4H139.15V9.61h8.43c5.33,0,8.93,3.83,8.93,7.93,0,3.33-2.32,5.56-3.47,5.56A7.84,7.84,0,0,1,160.42,31.09ZM144,14.32V22l3.83,0A3.88,3.88,0,0,0,152,18.17a4,4,0,0,0-4.1-3.85Zm11.71,16.44c0-2.34-2-4.48-5.5-4.48l-6.21,0v9.46h6.29A5.21,5.21,0,0,0,155.69,30.76Z",
    transform: "translate(-6.03 -2.28)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.12,14.38v7.91h11.69v4.83H169.12v8.55h13.55v4.82h-18.4V9.61h18.4v4.77Z",
    transform: "translate(-6.03 -2.28)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.68,40.49l-8.31-12h-3.8v12h-4.85V9.61h9.6a10.21,10.21,0,0,1,10.46,9.92,9,9,0,0,1-6.11,8.6l9,12.36Zm-7.26-16a5.27,5.27,0,0,0,5.35-5.09,5.17,5.17,0,0,0-5.35-5h-4.87v10.1Z",
    transform: "translate(-6.03 -2.28)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.35,35.8H218.73l-2.11,4.69h-5.25L225.89,9h.29l14.53,31.52h-5.25Zm-1.88-4.16-5.42-12.07-5.44,12.07Z",
    transform: "translate(-6.03 -2.28)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.85,23.32c1.79,0,5.41-3.47,5.41-8.67,0-6.4-5.62-12.37-13.93-12.37H10.18V32.43a18,18,0,0,0,18,18h0c9.57,0,15.15-7.3,15.15-14.68S37.26,23.32,31.85,23.32ZM17.71,9.63h6.07a6.2,6.2,0,0,1,6.39,6c0,3.43-2.75,6-6.48,6l-6,0Zm16.06,31.5c-1.79,1.73-3.71,3.32-5.7,5.09,0-.86,0-1.55,0-2.23,0-.4-.13-.49-.5-.51A8.1,8.1,0,0,1,20,34.82a8.12,8.12,0,0,1,16.09-.91A7.72,7.72,0,0,1,33.77,41.13Z",
    transform: "translate(-6.03 -2.28)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.69,49.26h0a2.91,2.91,0,0,0-4-.2c-7.25,6-15.06,7.79-23.25,5.14a32.4,32.4,0,0,1-9.75-5.26,2.9,2.9,0,0,0-3.83.23h0a2.9,2.9,0,0,0,.26,4.34,38.3,38.3,0,0,0,11.32,6.14,29.62,29.62,0,0,0,9.33,1.54c5.89,0,12.7-1.87,19.67-7.69A2.92,2.92,0,0,0,47.69,49.26Z",
    transform: "translate(-6.03 -2.28)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.06,36.7c-.11,0-.13,0-.18-.06q-1.81-3.28-3.64-6.57a.47.47,0,0,0-.17-.2h-.15l0,0a1.9,1.9,0,0,0-.76,2.5c.32.71.65,1.41,1,2.11s.71,1.53,1.07,2.29a.68.68,0,0,0,.66.42H28c.08,0,.11,0,.14.09.31.68.62,1.35.94,2a2,2,0,0,0,2,1.15,2,2,0,1,0-1.07-3.78Zm-2-.58a.32.32,0,0,1-.3-.32.31.31,0,0,1,.62,0A.31.31,0,0,1,28.05,36.12Zm3.87,2.38a1,1,0,1,1-2,0,1,1,0,0,1,2,0Z",
    transform: "translate(-6.03 -2.28)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.68,35l.06.08,0,0c.42-.9.84-1.79,1.25-2.69a1.8,1.8,0,0,0,.12-1.25,1.83,1.83,0,0,0-1-1.23h-.11a.65.65,0,0,0-.18.22l-1.41,2.54a.17.17,0,0,0,0,.17C28.87,33.53,29.28,34.26,29.68,35Z",
    transform: "translate(-6.03 -2.28)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.65,37.82a1.27,1.27,0,0,1-1-.77c-.09-.19-.18-.38-.27-.59a1,1,0,0,0-.11.2c0,.08-.07.09-.15.05a2,2,0,0,0-2.84,2.15,2,2,0,0,0,3.73.58c.25-.51.48-1,.72-1.55C27.71,37.85,27.71,37.83,27.65,37.82ZM25.21,39.5a1,1,0,1,1,1-1A1,1,0,0,1,25.21,39.5Z",
    transform: "translate(-6.03 -2.28)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarberaLogo);
export default __webpack_public_path__ + "static/media/barbera-logo.191b64f1b8690372db26e5ced9450d7b.svg";
export { ForwardRef as ReactComponent };